global.setImmediate = (callback) => {
  if (typeof window !== 'undefined' && window.setTimeout) {
    return window.setTimeout(callback, 0);
  }
  return setTimeout(callback, 0);
};
